import axios from 'axios'
import endpoints from '../../endpoints'
import {BusAttendeeBase} from './type'
import {APIResponse, NFCBase, NFCCreate} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchConductorList(): Promise<APIResponse<BusAttendeeBase[]>> {
  const response = await axios.get(API_URL + endpoints.conductor.list)
  return response.data
}

export async function createConductor(
  body: Omit<BusAttendeeBase, 'conductor_id'>
): Promise<APIResponse<null>> {
  const response = await axios.post(API_URL + endpoints.conductor.create, body)
  return response.data
}

export async function updateConductor(body: BusAttendeeBase): Promise<APIResponse<null>> {
  const response = await axios.post(API_URL + endpoints.conductor.update, body)
  return response.data
}

export async function deleteConductor(conductorId: string | number): Promise<APIResponse<null>> {
  const response = await axios.get(API_URL + endpoints.conductor.delete + conductorId)
  return response.data
}
export async function addNFCtoConductor(payload: NFCCreate) {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.createUserNFC, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function getConductorNFC(id: string): Promise<APIResponse<NFCBase>> {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.getUserNFC, {
      id,
      type: 'conductor',
    })
    return response.data
  } catch (error) {
    throw error
  }
}
